module.exports = __webpack_public_path__ + "media/images/icons/outlined/shake-4280cefc1ad8cd7060162f2d5cc34383.svg";